import fetch from 'isomorphic-fetch'
import {authHeader, handleResponse} from "./helpers";
import {API_URL} from "../../constants/Config";

export const settingsService = {
  getSetting,
  updateSetting,
  getSettingPromptTranslate
};

async function getSetting(auth_token, name, product) {
  const url = `${API_URL}/settings/${name}?${product ? 'product='+product : ''}`
  const options = {
    method: 'GET',
    headers: authHeader(auth_token)
  };
  return fetch(url, options)
    .then((response) => handleResponse(response))
    .then((response) => response.value);
}

async function getSettingPromptTranslate(auth_token, name, isDefault) {
  const url = `${API_URL}/settings/${name}?${isDefault ? 'default='+isDefault : ''}`
  const options = {
    method: 'GET',
    headers: authHeader(auth_token)
  };
  return fetch(url, options)
    .then((response) => handleResponse(response))
    .then((response) => response.value);
}

async function updateSetting(auth_token, name, value, product, notify) {
  const url = `${API_URL}/settings/${name}?${product ? 'product='+product+'&' : ''}${notify ? 'notify=true' : ''}`;
  const options = {
    method: 'POST',
    headers: authHeader(auth_token,{
      "Content-Type": "application/json",
    }),
    body: JSON.stringify({value: value})
  };
  return fetch(url, options)
    .then((response) => handleResponse(response));
}
